import React, { useState } from 'react';
import PropTypes from 'prop-types';
import VideoPlayer from "components/VideoPlayer";
import SliderProductsContainer from 'containers/SliderProducts';
import Link from 'components/Link';
import TagManagerService from 'services/TagManager';
import WrapperOptimizer from 'components/WrapperOptimizer';
import style from './style.scss'; //NOSONAR

let item = {};
const ProductsRecipes = (props) => {
    const [isVisible, setIsVisible] = useState(true);
    item = props && props.item ? props.item : [];


    const callbackNotProducts = (visibility = false) => {
        setIsVisible(visibility);
    }

    const _getContent = (contentData) => {
        let cont = contentData.map((element, i) => {

            switch (element.acf_fc_layout) {
                case 'collection': {
                    if(!(element || element.id)) return '';
                    return <div key={i} className="products-recipes-wrap slider">
                        <WrapperOptimizer typeComponent="home_sliders_products">
                            {(data) => {
                                return <SliderProductsContainer options={{ collections: 'H:' + element.id, position: item.countRecipes, filter: item.sales_channel}} callbackNotProducts={callbackNotProducts} listTitle={'Vitrina ' + item.shelfIsland} campaignData={data}/>
                            }}
                        </WrapperOptimizer>
                    </div>
                }
                case 'video': {
                    let _item = {
                        idVideo: element.url_video,
                        title: element.title
                    }
                    return (
                        <div key={i} className="products-recipes-wrap video">
                            <VideoPlayer data={_item} />
                        </div>
                    );
                }
            }
        });

        return cont;
    }

    const clickTagManager =  () => {
        TagManagerService.clickLink('Ver todos los productos', 'Products-Recipes', item.title);
    }

    if (!(item.content && item.content.length)) return '';

    const content = _getContent(item.content);

    if (!content || !content.length) return ''

    return (
        <section className={'products-recipes' + (isVisible ? ' show' : '')}>
            <div className="products-recipes-header">
                <h3 className="products-recipes-title">{item.title}</h3>
                <Link className="new-link home-section-link" to={item.url} target={item.url_target} onClick={() => clickTagManager()}>
                    <span className='home-section-link-text'>Ver más</span>
                </Link>
            </div>
            <div className="products-recipes-body">
                {content}
            </div>

        </section>
    )

};

ProductsRecipes.propTypes = {
    item: PropTypes.object
};

export default ProductsRecipes;


